import { render, staticRenderFns } from "./IssueButton.vue?vue&type=template&id=3b8e5cfa&"
import script from "./IssueButton.vue?vue&type=script&lang=js&"
export * from "./IssueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports